/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals  _:true, page_data: true, Drupal: true, YT:true, jQuery:true, TweenMax:true, window:true, navigator:true, TimelineMax:true, Spinner:true, Sector:true, site:true*/

(function ($) {
  'use strict';

  Drupal.behaviors.ModuleVBBoutique = {
    attach: function () {
      // /////////////////////////////////
      // BEGIN: Utility Functions
      // /////////////////////////////////
      /**
      * @function getInternetExplorerVersion
      * @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
      * @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
      * @returns {Number} -1 if not any IE version, any other number otherwise
      */
      function getInternetExplorerVersion() {
        var rv = -1;
        var ua;
        var re;
        var verStringArr;

        // works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
        if (navigator.appName === 'Microsoft Internet Explorer') {
          ua = navigator.userAgent;
          re = /'MSIE ([0-9]{1,}[\.0-9]{0,})'/;

          if (re.exec(ua) !== null) {
            rv = parseFloat(RegExp.$1);
          }
        } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Trident') > -1) {
          rv = 11;
        } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Edge') > -1) {
          ua = navigator.userAgent;
          re = /'Edge\/([0-9]{1,}[\.0-9]{0,})'/;
          verStringArr = re.exec(ua);

          if (verStringArr.length !== 0) {
            rv = Math.floor(parseFloat(verStringArr[0].split('/')[1]));
          }
        }

        return rv;
      }

      // /////////////////////////////////
      // END: Utility Functions
      // /////////////////////////////////

      // /////////////////////////////////
      // BEGIN: Boutique Implementation
      // /////////////////////////////////
      (function () {
        // DOM Elements
        var MAIN = new Sector({
          loop: true,
          debug: false
        });
        var $window = $(window);
        var $body = $('body');
        var $siteContainer = $('#vb_container');
        // debug
        var debug = typeof $siteContainer.data('debug') !== 'undefined'; // window.location.search.indexOf('debug=true') !== -1,
        // Platform check vars
        var mobileSize;
        var isMobile;
        var isIpad;
        var isDesktop;
        var ieVersion;
        // Misc Vars
        var soldOutProductIDs = []; // Handles sold out products, see prodcat.status event handling
        var youtubeAPIReady = false;
        var deeplink;
        var deeplinking = false;
        // Deeplink Handling
        var deeplinkSectionIDPart = 'vb_section-';

        {
          mobileSize = 640;
          // Initial mobile checks (additional checks will be needed for 'desktop mobile' sizes)
          isMobile = typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
          isDesktop = !isMobile;
          isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;
          ieVersion = getInternetExplorerVersion();

          // set classes for desktop/mobile/ipad/ie
          if (isIpad) {
            $body.addClass('ipad');
          } else {
            $body.addClass(isMobile ? 'mobile' : 'desktop');
          }

          if (ieVersion !== -1) {
            $body.addClass('ie');
          }

          if (ieVersion === 9) {
            $body.addClass('ie-9');
          }

          if (isDesktop) {
            isMobile = $(window).width() <= 640;
            if (isMobile) {
              $body.addClass('mobile');
            }
          }
        }

        // BEGIN: Deeplink handling
        deeplink = {
          get: function () {
            var hashRaw = window.location.hash;
            var hashData = hashRaw.split('/');

            hashData.splice(0, 1);

            return hashData;
          },
          set: function (value) {
            var hashString = '';
            var hashValue;
            var h = 0;

            if (typeof value === 'string' || typeof value === 'number') {
              window.location.replace('#/' + value);
            } else if (typeof value === 'object' && value instanceof Array) {
              for (h = 0; h < value.length; h++) {
                hashValue = value[h];

                if (typeof hashValue === 'string' || typeof hashValue === 'number') {
                  hashString += (hashString.length === 0 ? '' : '\/') + hashValue;
                }
              }

              window.location.replace('#/' + hashString);
            }
          }
        };
        // END: Deeplink Handling

        // BEGIN: Init
        {
          TweenMax.set($('#vb_section-1 .vb-collection-year'), { opacity: 0 });

          // Listen for youtube API ready
          window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
            youtubeAPIReady = true;

            $window.trigger('youtubeReady');
          };
        }
        // END: Init

        // Customize global sector JS functionality here
        /**
        * @function generateSection
        * @description Generates Sector JS arguments from a given section and options
        * @param {jQuery} $element Section to generate section data JS arguments from
        * @param {object} options  Object to customize this function's functionality
        * @returns {object} Prepared argument for Sector JS
        */
        function generateSection($element, options) {
          var elementId = $element.attr('id');

          if (typeof $element === 'undefined' || $element.length === 0) {
            return;
          }

          options = $.extend({}, options);

          return {
            element: $element,
            load: function () {
              if (debug) {
                console.log(elementId + ': load');
              }

              if (typeof options.load === 'function') {
                options.load.apply(this, arguments);
              }
            },
            unload: function () {
              if (debug) {
                console.log(elementId + ': unload');
              }

              $element.removeClass('active');

              if (typeof options.unload === 'function') {
                options.unload.apply(this, arguments);
              }
            },
            update: function () {
              if (debug) {
                console.log(elementId + ': update');
              }

              if (arguments[0] >= 0.4) {
                $element.addClass('active');
              } else {
                $element.removeClass('active');
              }

              // Do not allow updates if deeplinking
              if (deeplinking) {
                return;
              }

              if (typeof options.update === 'function') {
                options.update.apply(this, arguments);
              }
            },
            deeplink: function () {
              if (debug) {
                console.log(elementId + ': deeplink');
              }

              // No need to deeplink for first section
              if ($siteContainer.find('.vb_section').index($element) !== 0) {
                TweenMax.to($window, 1, {
                  scrollTo: {
                    y: $element.offset().top,
                    autokill: false
                  },
                  onComplete: function () {
                    deeplinking = false;
                    MAIN.update(true);
                  }
                });
              } else {
                deeplinking = false;
                MAIN.update(true);
              }

              // Ensure the deeplinking is "off" after a set time
              window.setTimeout(function () {
                deeplinking = false;
                MAIN.update(true);
              }, 2000);

              if (typeof options.deeplink === 'function') {
                options.deeplink.apply(this, arguments);
              }
            }
          };
        }

        var postLoad = function () {
          // Resize handler that should trigger resize handling with a delay after a resize
          // Implementation done to throttle resize event calls
          var resizeHandler = _.debounce(function () {
            /*
               Required for section load, unload, and update functions called by this function
               There may be additional animations and functionality implemented in those functions that need to be called.
               Calling this after resize insures that sections "now" in view get updated while sections that are "now" out of view are unloaded
            */
            MAIN.update(true);

            // Add mobile class if desktop class scales under mobile size
            if (isDesktop) {
              if ($window.width() <= mobileSize && !$body.hasClass('mobile')) {
                $body.addClass('mobile');
                isMobile = true;
                $(window).trigger('desktopGainedMobile');
              } else if ($window.width() > mobileSize && $body.hasClass('mobile')) {
                $body.removeClass('mobile');
                isMobile = false;
                $(window).trigger('desktopLostMobile');
              }
            }
          }, 500);

          if (debug) {
            console.log('postLoad fired');
          }

          /*
            Scroll handling, also covers touchmove and touchend for smoother iOS updates
          */
          $window.on('scroll touchmove touchend', function () {
            var $activeSections;

            /*
               Required for section load, unload, and update functions called by this function
               There may be additional animations and functionality implemented in those functions that need to be called.
            */
            MAIN.update(true);

            $activeSections = $siteContainer.find('.vb_section.active');

            // Update deeplink if not currently deeplinking, if there are sections, and window isn't at maximum scroll
            if (!deeplinking && $activeSections.length !== 0 && $window.scrollTop() !== $('body').height() - $(window).height()) {
              deeplink.set($activeSections.first().attr('id').replace(deeplinkSectionIDPart, ''));
            }
            // Updated deeplink to last section if window is at maximum scroll
            // Implemented due to previous section catching deeplink conditions, while the last section almost never does
            else if ($window.scrollTop() === $('body').height() - $(window).height()) {
              deeplink.set($activeSections.last().attr('id').replace(deeplinkSectionIDPart, ''));
            }
          });

          // on resize update MAIN and update desktop/mobile classes
          $window.resize(resizeHandler).trigger('resize');

          // Process products in product list against products in section 6, assigning classes for visual filtering.
          // MPP setup
          (function () {
            // DOM
            var $faceProducts = $siteContainer.find('#face_products');
            var $eyeProducts = $siteContainer.find('#eyes_products');
            var $lipsProducts = $siteContainer.find('#lips_products');
            var $products = $siteContainer.find('.mpp__product');
            // LOGIC
            var faceProducts = [];
            var eyeProducts = [];
            var lipsProducts = [];
            var customMPP;
            var productsData;

            // Make sure page_data is not undefined
            // Continue doing this for proceeding properties until products array is hit
            if (typeof page_data !== 'undefined') {
              customMPP = page_data['custom-mpp'];

              if (typeof customMPP !== 'undefined') {
                productsData = customMPP['products'];
              }
            }

            // If there are no products, assume mobile version of site, which uses '.product-brief'
            if ($products.length === 0) {
              $products = $siteContainer.find('.product-brief');
            }

            // Populate products
            if ($faceProducts.length !== 0) {
              faceProducts = $faceProducts.html().split(',');
            }

            if ($eyeProducts.length !== 0) {
              eyeProducts = $eyeProducts.html().split(',');
            }

            if ($lipsProducts.length !== 0) {
              lipsProducts = $lipsProducts.html().split(',');
            }

            function trimProductIDs(arrProducts) {
              var p = 0;

              // Clear whitespace
              for (p = 0; p < arrProducts.length; p++) {
                arrProducts[p] = arrProducts[p].trim();
              }
            }

            // Ensure that whitespace has been cleared
            trimProductIDs(faceProducts);
            trimProductIDs(eyeProducts);
            trimProductIDs(lipsProducts);

            // Assign classes to products found in each category

            $products.each(function () {
              var $this = $(this);
              var productID = $this.data('productid');
              var p = 0;
              var productData;
              var skus;
              var skuData;

              if (debug) {
                console.log('mpp labeler: looking for ' + productID + ' in ' + faceProducts, eyeProducts, lipsProducts);
              }

              if (faceProducts.indexOf(productID) !== -1) {
                $this.addClass('face');

                if (debug) {
                  console.log('mpp labeler: found product: face ' + productID, $this);
                }
              } else if (eyeProducts.indexOf(productID) !== -1) {
                $this.addClass('eye');

                if (debug) {
                  console.log('mpp labeler: found product: eye ' + productID, $this);
                }
              } else if (lipsProducts.indexOf(productID) !== -1) {
                $this.addClass('lips');

                if (debug) {
                  console.log('mpp labeler: found product: lips ' + productID, $this);
                }
              } else if (debug) {
                console.log('mpp labeler: could not find in list product with ID ' + productID, $this);
              }

              // Assign SKUs per product based on page_data values (if it exists)
              // ... And is an Array
              if (typeof productsData !== 'undefined' && productsData instanceof Array) {
                for (p = 0; p < productsData.length; p++) {
                  productData = productsData[p];

                  if (typeof productData['PRODUCT_ID'] !== 'undefined' && productData['PRODUCT_ID'] === productID) {
                    skus = productData['skus'];
                    if (typeof skus !== 'undefined' && skus instanceof Array) {
                      // Use first sku data
                      skuData = skus[0];

                      if (typeof skuData['SKU_ID'] !== 'undefined') {
                        $this.attr('data-sku-base-id', skuData['SKU_ID']);
                        break;
                      }
                    }
                  }
                }
              }
            });
          })();

          // BEGIN: CTA Button Handling
          (function () {
            /*
              Three kinds of CTA's
              - Add to bag: Adds product to bag
              - Quickshop: Opens a new quickshop window
              - Shop Now: Just a link
            */
            function getProductData(productID, SKU) {
              var property;
              var product;
              var products;
              var p2 = 0;
              var p3 = 0;

              if (typeof productID === 'undefined') {
                return;
              }

              // Look for product ID in each page_data field that has products
              for (property in page_data) {
                if (page_data.hasOwnProperty(property) && typeof page_data[property].products !== 'undefined') {
                  products = page_data[property].products;

                  for (p2 = 0; p2 < products.length; p2++) {
                    product = products[p2];
                    if (product.PRODUCT_ID === productID) {
                      // Return first SKU data
                      if (typeof SKU === 'undefined') {
                        if (product.skus.length !== 0 && typeof product.skus[0].SKU_ID !== 'undefined') {
                          return product.skus[0];
                        }
                      }
                      // Look for specific SKU if target SKU is defined
                      else {
                        if (product.skus.length !== 0) {
                          for (p3 = 0; p3 < product.skus.length; p3++) {
                            if (product.skus[p3].SKU_ID === SKU) {
                              return product.skus[p3];
                            }
                          }

                          // Otherwise return first SKU
                          return product.skus[0];
                        }
                      }
                    }
                  }
                }
              }
            }

            // BEGIN: INIT
            {
              // Append relevant data form page data to each CTA
              $('.cta').each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var productID = $this.data('product-id');
                var SKU = $this.data('SKU');
                var productData = getProductData(productID, SKU);

                if (typeof productData === 'undefined') {
                  return;
                } else {
                  $this.addClass('ready');
                  $this.data('productData', productData);
                  $this.attr('href', productData.url);
                }
              });
            }
            // END: INIT

            // BEGIN: EVENTS
            {
              $('.cta.add-to-bag').on('click', function (e) {
                // DOM
                var $this = $(this);
                // LOGIC
                var productID = $this.data('product-id');

                e.preventDefault();

                if (!$this.hasClass('ready')) {
                  return;
                }

                if (typeof productID !== 'undefined') {
                  site.addToCart({
                    skuData: {
                      SKU_BASE_ID: $this.data('productData').SKU_ID.substr(3),
                      PARENT_CAT_ID: productID
                    },
                    quantity: 1,
                    QTY: 1
                  });
                }
              });

              $('.cta.quickshop').on('click', function (e) {
                // DOM
                var $this = $(this);

                e.preventDefault();

                if (!$this.hasClass('ready')) {
                  return;
                }

                site.quickshop($this.data('productData'));
              });
            }
            // END: EVENTS
          })();
          // END: CTA Button Handling

          // Trigger postLoad event
          $window.trigger('postLoad');
        };

        /**
        * @function setProductsAndSkus
        * @description Assigns product IDs and SKUs to the .el-product elements
        * @param {jQuery} $selector Section to generate section data JS arguments from
        */
        function setProductsAndSkus($selector) {
          // DOM
          var $products = $selector.find('.el-product');
          var $hiddenList = $selector.parent().find('.hidden_product_list');
          // LOGIC
          var productIDs = [];
          var customMPP;
          var productsData;

          // trim trailing comma and collect product IDs
          $hiddenList.text($hiddenList.text().slice(0, -1));
          productIDs = $hiddenList.text().split(',');

          // Make sure page_data is not undefined
          // Continue doing this for proceeding properties until products array is hit
          if (typeof page_data !== 'undefined') {
            customMPP = page_data['custom-mpp'];
            if (typeof customMPP !== 'undefined') {
              productsData = customMPP['products'];
            }
          }

          $products.not('.empty').each(function (index, element) {
            var $this = $(element);
            var $thisShopButton = $this.find('.el-product_shop-now');
            var productID = productIDs[index];
            var p = 0;
            var productData;
            var skus;
            var skuData;

            // Add the product ID to the data-product value for this element
            $this.data('product', productIDs[index]);
            $thisShopButton.data('product', productIDs[index]);

            if (typeof productsData !== 'undefined' && productsData instanceof Array) {
              for (p = 0; p < productsData.length; p++) {
                productData = productsData[p];

                if (typeof productData['PRODUCT_ID'] !== 'undefined' && productData['PRODUCT_ID'] === productID) {
                  skus = productData['skus'];

                  if (typeof skus !== 'undefined' && skus instanceof Array) {
                    skuData = skus[0]; // Use first sku data

                    if (typeof skuData['SKU_ID'] !== 'undefined') {
                      $this.data('sku', skuData['SKU_ID']);
                      $thisShopButton.data('sku', skuData['SKU_ID']);
                      break;
                    }
                  }
                }
              }
            }
          });
        }

        // Fires on postLoad to ensure _all_ content is loaded per slide before setting up section functionality
        $(window).on('postLoad', function () {
          // /////////////////////////////
          // BEGIN: General Events
          // /////////////////////////////
          (function () {
            var $elProducts = $('.el-product');

            function markELProductsSoldOut() {
              // Mark products as sold out
              $elProducts.each(function () {
                var $this = $(this);
                var productID = $this.data('product');
                var $button = $this.find('.el-product_shop-now');

                if (typeof productID !== 'undefined' && productID.length !== 0 && soldOutProductIDs.indexOf(productID) !== -1) {
                  $button.text('Sold out').addClass('sold-out').off('click');
                }
              });
            }

            /*
            // singular product quickshop/add to bag
            $siteContainer.find('.el-product_shop-now').not('.quickshop, .empty').on('click', function(e) {
              e.preventDefault();
              var $this = $(this);

              // if shop button is tied to add-to-bag run addToCart, else do quickshop
              if ($this.hasClass('add-to-bag')) {
                // add the item to the cart
                site.addToCart({
                  skuData : {
                    SKU_BASE_ID : $this.attr('data-sku').substr(3),
                    PARENT_CAT_ID : $this.attr('data-product')
                  },
                  quantity : 1,
                  QTY : 1
                });
              }
            });
            */

            // If soldOutProductIDs has elements, mark elproducts as sold out based on prodIDs within
            if (soldOutProductIDs.length !== 0) {
              markELProductsSoldOut();
            }

            // If soldOutProductIDs has been populated 'late' do the same as above
            $(window).on('updateProductsToSoldOut', function () {
              markELProductsSoldOut();
            });
          })();
          // /////////////////////////////
          // END: General Events
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 1
          // /////////////////////////////
          (function () {
            // DOM
            var $self = $siteContainer.find('#vb_section-1');
            var $logo = $self.find('.vb-logo');
            var $backgroundImage = $self.find('.background');
            var $text = $self.find('.vb_section-full_text');
            var $signatureCover = $self.find('.vb_section-signature-image_cover');
            // LOGIC
            var backgroundOffset; // Used for autoscroll
            var backgroundHeight;
            // Intro animation
            var introTimeline;
            var introPlayed = false;

            if ($self.length === 0) {
              return;
            }

            // Animation
            {
              introTimeline = new TimelineMax({
                paused: true,
                onComplete: function () {
                  $self.addClass('introComplete');
                }
              });
            }

            MAIN.add(generateSection($self, {
              update: function (position) {
                if (!introPlayed && position >= 0.6) {
                  // Intro animation parts for "scroll to" text as initial creation doesn't seem to catch
                  // Background image heights correctly
                  backgroundOffset = $backgroundImage.filter(isMobile ? '.mobile' : '.desktop').offset().top;
                  backgroundHeight = $backgroundImage.filter(isMobile ? '.mobile' : '.desktop')[0].clientHeight;

                  introTimeline
                    .to($backgroundImage, 1.5, { opacity: 1 })
                    .fromTo($logo, 0.5, {
                      y: '60%',
                      opacity: 0
                    }, {
                      y: '0%',
                      opacity: 1
                    })
                    .fromTo($self.find('.vb-collection-year'), 0.5, {
                      y: '60%',
                      opacity: 0
                    }, {
                      y: '0%',
                      opacity: 1
                    }, '-=0.25')
                    .to($window, 1, {
                      scrollTo: {
                        y: $self.offset().top + $self.outerHeight(true) - $window.height() + $('footer .page-sticky-footer').height(),
                        autoKill: false
                      },
                      delay: 0.5
                    });

                  if (isMobile) {
                    TweenMax.set($text, { opacity: 1 });

                    introTimeline
                      .add([
                        TweenMax.fromTo($text.find('p'), 1, {
                          y: '20%',
                          opacity: 0
                        }, {
                          y: '0%',
                          opacity: 1
                        }),
                        TweenMax.fromTo($signatureCover, 3, { left: '50%' }, { left: '100%' })
                      ], '+=0', 'normal', 0.2);
                  } else {
                    introTimeline
                      .add([
                        TweenMax.fromTo($text, 1, { y: '20%' }, {
                          y: '0%',
                          opacity: 1
                        }),
                        TweenMax.fromTo($signatureCover, 3, { left: '50%' }, { left: '100%' })
                      ], '+=0', 'normal', 0.2);
                  }

                  introTimeline.play();
                  introPlayed = true;
                }
              }
            }));
          })();
          // /////////////////////////////
          // END: Section 1
          // ////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 3
          // /////////////////////////////
          (function () {
            // DOM
            var $self = $siteContainer.find('#vb_section-3');
            var $columns = $self.find('.columns-container').children();
            // LOGIC
            // Intro animation
            var introTimeline;
            var introTimelineStarted = false;

            if ($self.length === 0) {
              return;
            }

            // BEGIN: Init
            {
              introTimeline = new TimelineMax({
                paused: true
              });

              introTimeline
                .staggerFrom($columns, 1, {
                  y: '20%',
                  opacity: 0,
                  clearProps: 'transform'
                }, 0.5);
            }
            // END: Init

            // BEGIN: Events
            {
              $self.find('.column.right .quickshop').on('click', function (e) {
                // DOM
                var $this = $(this);
                var $parent = $this.closest('.content');
                var $quickshop = $parent.find('.el-product');

                e.preventDefault();
                site.quickshop($quickshop.data('full_product_json'));
              });

              // Scrolls to selector with target data value
              $self.find('.column.left .el-product_shop-now-container a').on('click', function (e) {
                // DOM
                var $this = $(this);
                var $target;
                // LOGIC
                var target = $this.data('scroll-target');
                var offset = $siteContainer.offset().top;

                e.preventDefault();

                if (typeof target !== 'string' || target.trim().length === 0) {
                  return;
                }

                $target = $(target);

                if ($target.length === 0) {
                  return;
                }

                TweenMax.to($window, 1, {
                  scrollTo: {
                    y: $target.offset().top - offset,
                    autoKill: false
                  }
                });
              });
            }
            // END: Events

            MAIN.add(generateSection($self, {
              update: function (position) {
                if (!introTimelineStarted && position >= 0.4) {
                  introTimeline.play();
                  introTimelineStarted = true;
                }
              }
            }));
          })();
          // /////////////////////////////
          // END: Section 3
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 3-5
          // /////////////////////////////
          (function () {
            // DOM
            var $self = $siteContainer.find('#vb_section-3-5');
            var $carousel = $self.find('.carousel');
            var $arrowLeft = $self.find('.arrow.left');
            var $arrowRight = $self.find('.arrow.right');
            var $pagination = $self.find('.carousel_pagination .dot');
            var $videoCloseButton = $self.find('.close_btn');
            // LOGIC
            var timerPlayerUpdate;
            var animationIntro;
            var animationIntroStarted = false;

            if ($self.length === 0) {
              return;
            }

            function initYoutube() {
              if (youtubeAPIReady) {
                // CHQUn741YvQ
                $carousel.children().each(function () {
                  // DOM
                  var $this = $(this);
                  var $videoContainer = $this.find('.video-container');
                  var $videoPlayer = $videoContainer.find('.video-player');
                  // LOGIC
                  var youtubeID;
                  var player = $this.data('video');

                  if (typeof player === 'undefined' && $videoContainer.length !== 0) {
                    youtubeID = $videoPlayer.data('youtube-id');

                    // Must have youtube ID
                    if (typeof youtubeID === 'undefined') {
                      return;
                    }

                    //                    console.log('found video container with this youtube ID ' + youtubeID);

                    player = new YT.Player($videoPlayer[0], {
                      videoId: youtubeID,
                      playerVars: {
                        autoplay: 0,
                        cc_load_policy: 0,
                        iv_load_policy: 1,
                        color: 'red',
                        controls: 0,
                        html5: 1,
                        playsinline: 1,
                        rel: 0,
                        modestbranding: 1,
                        showinfo: 1,
                        wmode: 'transparent',
                        enablejsapi: 1
                      },
                      events: {
                        onStateChange: function (e) {
                          var $scrubber = $this.find('.inner_scrubber');
                          var $playButton = $this.find('.play_btn');

                          // Set play to active and start progress update timer
                          if (e.data === 1 || e.data === 3 || e.data === -1) {
                            $playButton.addClass('active');

                            clearInterval(timerPlayerUpdate);

                            timerPlayerUpdate = setInterval(function () {
                              var duration = player.getDuration();
                              var currentTime = player.getCurrentTime();
                              var progress = currentTime / duration;

                              $scrubber.css('width', (progress * 100) + '%');
                            }, 500);
                          } else if (e.data === 0 || e.data === -1 || e.data === 2) {
                            $playButton.removeClass('active');

                            clearInterval(timerPlayerUpdate);

                            if (e.data !== 2) {
                              $scrubber.css('width', '');

                              $videoCloseButton.trigger('click');
                            }
                          }
                        }
                      }
                    });

                    $this.data('video', player);
                  } else if (debug) {
                    console.log('vb_section-3-5: init: player already created');
                  }

                  TweenMax.set($videoContainer.find('.video-player'), { display: 'none' });
                });
              } else if (debug) {
                console.log('Youtube API not initialized');
              }
            }

            // BEGIN: Init
            {
              $videoCloseButton.css({ display: 'none' });

              // Build and prepare for animations per slide
              $carousel.children().each(function () {
                // DOM
                var $this = $(this);
                var $text = $this.find('.vb_section-full_text');
                var $controls = $this.find('.controls');

                $this.data('animation', TweenMax.fromTo($text, 0.5, {
                  opacity: 0,
                  y: '60%'
                }, {
                  opacity: 1,
                  y: '0%',
                  paused: true,
                  delay: 0.5
                }));
                $controls.css({ opacity: 0 }).addClass('hidden');
              });

              // Create carousel, this will be disabled or enabled based on current mode
              $carousel.el_carousel({
                useGSAP: true,
                increment: '100%',
                duration: 0.5,
                debug: debug
              });

              initYoutube();

              $carousel.children().first().addClass('first');

              // Prep for intro animation
              $carousel.children().not(':first-child').css({
                display: 'none',
                opacity: 0
              });

              // Intro animation
              animationIntro = TweenMax.from($carousel.children().first(), 1, {
                x: '15%',
                opacity: 0,
                clearProps: 'transform',
                paused: true,
                onComplete: function () {
                  $carousel.children().css({
                    display: '',
                    opacity: ''
                  });

                  $carousel.children().first().trigger('slideWillGainActive');
                }
              });
            }
            // END: Init

            // BEGIN: Events
            {
              $window
                .on('youtubeReady', function () {
                  initYoutube();
                })
                .on('desktopLostMobile', function () {
                  // Ensure that arrows are always visible in desktop mode
                  $arrowLeft.add($arrowRight).css({
                    display: '',
                    opacity: ''
                  });
                });

              $videoCloseButton.on('click', function (e) {
                // DOM
                var $this = $(this);
                var $activeSlide = $carousel.children('.active');
                // LOGIC
                var player = $activeSlide.data('video');

                e.preventDefault();

                if (typeof player !== 'undefined' && typeof player.pauseVideo === 'function') {
                  player.pauseVideo();
                }

                if (isMobile) {
                  TweenMax.to([$arrowLeft, $arrowRight], 0.5, {
                    display: 'block',
                    opacity: 1
                  });
                }

                TweenMax.to($this, 0.5, {
                  opacity: 0,
                  display: 'none'
                });
                TweenMax.set($activeSlide.find('.video-player'), { display: 'none' });
                TweenMax.to($activeSlide.find('.video-thumbnail-container'), 0.5, {
                  opacity: 1,
                  display: 'block'
                });
                TweenMax.to($activeSlide.find('.controls'), 0.5, { opacity: 0 });
                $activeSlide.find('.controls').addClass('hidden');
              });

              $carousel.find('.play_btn').on('click', function (e) {
                // DOM
                var $this = $(this);
                var $parent = $this.parentsUntil($carousel).last();
                var $parentControlsMask = $this.closest('.controls');
                // LOGIC
                var player = $parent.data('video');

                e.preventDefault();

                if ($parentControlsMask.hasClass('hidden')) {
                  return;
                }

                if (typeof player !== 'undefined') {
                  if (player.getPlayerState() !== 1) {
                    player.playVideo();
                    $this.addClass('active');
                  } else {
                    player.pauseVideo();
                    $this.removeClass('active');
                  }
                }
              });

              $carousel.find('.scrubber-container').on('click', function (e) {
                // DOM
                var $this = $(this);
                var $parent = $this.parentsUntil($carousel).last();
                var $parentControlsMask = $this.closest('.controls');
                // LOGIC
                var player = $parent.data('video');
                var position = e.clientX - $this.offset().left;
                var duration;
                var progress = position / $this.width();

                e.preventDefault();

                if ($parentControlsMask.hasClass('hidden')) {
                  return;
                }

                if (typeof player !== 'undefined') {
                  duration = player.getDuration();
                  player.seekTo(duration * progress);
                }
              });

              $carousel.find('.full_btn').on('click', function (e) {
                // DOM
                var $this = $(this);
                var $parent = $this.parentsUntil($carousel).last();
                var $parentControlsMask = $this.closest('.controls');
                var $player = $parent.find('iframe');
                // LOGIC
                var requestFullScreen;

                e.preventDefault();

                if ($player.length === 0 || $parentControlsMask.hasClass('hidden')) {
                  return;
                }

                requestFullScreen = $player[0].requestFullScreen || $player[0].mozRequestFullScreen || $player[0].webkitRequestFullScreen;
                requestFullScreen.call($player[0]);
              });

              $carousel.find('.slide')
                .on('slideWillGainActive', function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var animation = $this.data('animation');

                  if (typeof animation !== 'undefined') {
                    animation.play();
                  }
                });

              $carousel.find('.video-thumbnail-container').on('click', function (e) {
                // DOM
                var $this = $(this);
                var $parent = $this.parentsUntil($carousel).last();
                // LOGIC
                var videoPlayer = $parent.data('video');

                e.preventDefault();

                if (typeof videoPlayer !== 'undefined' && typeof videoPlayer.playVideo === 'function') {
                  if (isMobile) {
                    TweenMax.to([$arrowLeft, $arrowRight], 0.5, {
                      display: 'none',
                      opacity: 0
                    });
                  }

                  TweenMax.to($videoCloseButton, 0.5, {
                    opacity: 1,
                    display: 'block'
                  });
                  TweenMax.set($parent.find('.video-player'), { display: 'block' });
                  TweenMax.to($this, 0.5, {
                    opacity: 0,
                    display: 'none'
                  });
                  TweenMax.to($parent.find('.controls'), 0.5, { opacity: 1 });
                  $parent.find('.controls').removeClass('hidden');
                  videoPlayer.playVideo();
                }
              });

              $carousel.on('carouselCloneCreated', function (e, $clones) {
                $clones = $($clones);
                $clones.find('iframe').remove();
              });

              // Carousel controls
              $arrowLeft.on('click', function (e) {
                e.preventDefault();
                $carousel.carouselPrev();
              });

              $arrowRight.on('click', function (e) {
                e.preventDefault();
                $carousel.carouselNext();
              });

              $self.swipe({
                swipeLeft: function () {
                  $carousel.carouselNext();
                },
                swipeRight: function () {
                  $carousel.carouselPrev();
                },
                excludedElements: 'button, input, select, textarea, .noSwipe',
                preventDefaultEvents: false
              });

              $pagination.on('click', function (e) {
                var $this = $(this);
                var index = $this.index();

                e.preventDefault();

                // Do not allow carousel if see the look is actuve
                if ($self.hasClass('see-the-look-active')) {
                  return;
                }

                $this.addClass('active').siblings().removeClass('active');
                $carousel.carouselTo(index);
              });

              // Updates the pagination dots when carousel updates
              $carousel.on('carousel_updated', function (e, index) {
                var $slide = $carousel.children().eq(index);
                var animation = $slide.data('animation');

                $slide.siblings().each(function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var video = $this.data('video');

                  if (typeof video !== 'undefined' && typeof video.pauseVideo === 'function') {
                    video.pauseVideo();
                  }

                  $videoCloseButton.trigger('click');
                });

                $pagination.eq(index).addClass('active').siblings().removeClass('active');

                if (!$slide.hasClass('active')) {
                  if (typeof animation !== 'undefined') {
                    animation.progress(0);
                  }
                }
              });

              $window.on('keydown', function (e) {
                if (!$self.hasClass('active')) {
                  return;
                }

                switch (e.which) {
                  // Left arrow
                  case 37:

                    $carousel.carouselPrev();
                    break;

                  // Right arrow
                  case 39:

                    $carousel.carouselNext();
                    break;
                }
              });
            }
            // END: Events

            // BEGIN: Post Init
            {
              // Force text to animate in for the first slide
              $carousel.children().first().trigger('slideWillGainActive');
            }
            // END: Post Init

            MAIN.add(generateSection($self, {
              update: function (position) {
                if (!animationIntroStarted && position >= 0.4) {
                  animationIntro.play();
                  animationIntroStarted = true;
                }
              }
            }));
          })();
          // /////////////////////////////
          // END: Section 3-5
          // /////////////////////////////

          // ////////////////////////////
          // BEGIN: Section 4
          // /////////////////////////////
          (function () {
            // DOM
            var $self = $('#vb_section-4');
            // LOGIC
            var animationIntro = new TimelineMax({ paused: true });
            var animationIntroStarted = false;

            if ($self.length === 0) {
              return;
            }

            // BEGIN: Init
            {
              animationIntro
                .fromTo($self.find('.vb_section-full_text'), 1, {
                  opacity: 0,
                  y: '60%'
                }, {
                  opacity: 1,
                  y: '0%'
                });
            }
            // END: Init

            MAIN.add(generateSection($self, {
              update: function (position) {
                if (!animationIntroStarted && position >= 0.4) {
                  animationIntro.play();
                  animationIntroStarted = true;
                }
              }
            }));
          })();
          // ////////////////////////////
          // END: Section 4
          // /////////////////////////////

          // ////////////////////////////
          // BEGIN: Section 5
          // /////////////////////////////
          (function () {
            // DOM
            var $self = $siteContainer.find('#vb_section-5');
            var $carousel = $self.find('.carousel');
            var $arrowLeft = $self.find('.arrow.left');
            var $arrowRight = $self.find('.arrow.right');
            var $pagination = $self.find('.carousel_pagination .dot');
            // LOGIC
            // Intro animation
            var introTimeline;
            var introTimedlineStarted = false;
            // Mobile animation vars
            var $currentSlide;

            if ($self.length === 0) {
              return;
            }

            /**
            * @function setMobileMode
            * @description Clears events used for desktop
            * @returns {undefined} this function does not return anything
            */
            function setMobileMode() {
              if (debug) {
                console.log('#vb_section-5: setMobileMode');
              }

              $carousel.carouselDestroy();
              $carousel.children().attr('style', '');

              // Clear carousel stuff
              $carousel.carouselSetEnabled(false);
              $carousel
                .children()
                .css('left', '')
                .find('.columns-container.see-the-look')
                .filter('.mobileFinished')
                .css({
                  opacity: '0',
                  display: 'none'
                });

              // Clear see-the-look-active class
              $self.removeClass('see-the-look-active');

              // Unbind and disable events
              $arrowLeft.off('click');
              $arrowRight.off('click');
              $pagination.off('click');
              $carousel.off('carousel_updated');
              $window.off('keydown');
              $self.swipe('disable');
            }

            /**
            * @function setDesktopMode
            * @description Creates events needed for desktop functionality
            * @returns {undefined} This function doesn't return anything
            */
            function setDesktopMode() {
              if (debug) {
                console.log('#vb_section-5: setDesktopMode');
              }

              // Create carousel, this will be disabled or enabled based on current mode
              $carousel.el_carousel({
                useGSAP: true,
                increment: '100%',
                duration: 0.5,
                debug: debug
              });

              $currentSlide = $();

              // Enable carousel
              $carousel.carouselSetEnabled(true);
              // $carousel.carouselUpdate();
              $carousel
                .children()
                .not('.active')
                .find('.columns-container.see-the-look')
                .css({
                  opacity: '1',
                  transform: ''
                });

              // Clear see-the-look-active class
              $self.removeClass('see-the-look-active');

              // Carousel controls
              $arrowLeft.on('click', function (e) {
                e.preventDefault();
                $carousel.carouselPrev();
              });

              $arrowRight.on('click', function (e) {
                e.preventDefault();
                $carousel.carouselNext();
              });

              $pagination.on('click', function (e) {
                var $this = $(this);
                var index = $this.index();

                e.preventDefault();

                $this.addClass('active').siblings().removeClass('active');
                $carousel.carouselTo(index);
              });

              // Updates the pagination dots when carousel updates
              $carousel.on('carousel_updated', function (e, index) {
                var $slide = $carousel.children().eq(index);
                var $top = $slide.find('.columns-container').filter('.see-the-look');

                $pagination.eq(index).addClass('active').siblings().removeClass('active');

                $slide.removeClass('needs-intro');

                // Top see-the-look fadeout
                // Not needed until the intro animation completes
                if (introTimedlineStarted) {
                  TweenMax.to($top, 0.5, {
                    opacity: 0,
                    display: 'none',
                    delay: 1
                  });
                  $slide.siblings().not('.needs-intro').find('.see-the-look').css({
                    opacity: 0,
                    display: 'none'
                  });

                  return;
                }

                $slide.removeClass('see-the-look-active');
                // TweenMax.set($slide.siblings().find('.see-the-look'), {opacity: 1, display: 'table'});
              });

              $window.on('keydown', function (e) {
                if (!$self.hasClass('active')) {
                  return;
                }

                // Do not allow carousel if see the look is actuve
                if ($self.hasClass('see-the-look-active')) {
                  return;
                }

                switch (e.which) {
                  // Left arrow
                  case 37:

                    $carousel.carouselPrev();
                    break;

                  // Right arrow
                  case 39:

                    $carousel.carouselNext();
                    break;
                }
              });

              $self.swipe('enable');
            }

            /**
            * @function crossToggle
            * @description Handles panel opening when mousing over/out or clicking on the plus images found on slides. Must be called with call or apply for scoping
            * @param {object} e - Event Object
            * @param {boolean} enable - Override to open or close panel, true to open, false to close
            * @returns {undefined} This function does not return anything
            */
            function crossToggle(e, enable) {
              /* jshint validthis: true */
              var $this = $(this);
              var $slide = $this.closest('.slide');
              var $crossPlus = $this.find('a');
              var $panel = $slide.find('.panel');
              var $panelText = $slide.find('.vb_section-half_text');

              e.preventDefault();

              if ($crossPlus.hasClass('open') || (typeof enable !== 'undefined' && enable)) {
                $crossPlus.removeClass('open').addClass('close');

                // Ensure tweens are stopped for each element
                TweenMax.killTweensOf($crossPlus);
                TweenMax.killTweensOf($panel);
                TweenMax.killTweensOf($panelText);

                TweenMax.to($crossPlus, 0.1, {
                  rotation: 45,
                  zIndex: 1
                });
                if (!isMobile) {
                  TweenMax.to($panelText, 0.3, { opacity: 0 });
                }
                TweenMax.to($panel, 0.3, {
                  opacity: 1,
                  display: 'block'
                });
              } else if ($crossPlus.hasClass('close') || (typeof enable !== 'undefined' && !enable)) {
                $crossPlus.addClass('open').removeClass('close');

                // Ensure tweens are stopped for each element
                TweenMax.killTweensOf($crossPlus);
                TweenMax.killTweensOf($panel);
                TweenMax.killTweensOf($panelText);

                TweenMax.to($crossPlus, 0.1, {
                  rotation: 0,
                  zIndex: 0
                });
                if (!isMobile) {
                  TweenMax.to($panelText, 0.3, { opacity: 1 });
                }
                TweenMax.to($panel, 0.3, {
                  opacity: 0,
                  display: 'none'
                });
              }
            }

            // BEGIN: Init
            {
              introTimeline = new TimelineMax({
                paused: true,
                onComplete: function () {
                  $self.removeClass('intro');
                }
              });

              if (isMobile) {
                $currentSlide = $carousel.find('.first');
                TweenMax.set($siteContainer.find('.see-the-look'), {
                  opacity: 1,
                  display: 'block'
                });

                introTimeline
                  .fromTo($currentSlide, 1, { opacity: 0 }, { opacity: 1 });
              } else {
                TweenMax.set($arrowLeft.add($arrowRight).find('img'), { opacity: 0 });

                introTimeline
                  .from($carousel.children().first(), 1, {
                    x: '15%',
                    opacity: 0,
                    clearProps: 'transform'
                  })
                  .to($carousel.children().first().find('.column'), 1, { opacity: 1 }, '-=1')
                  .to($arrowLeft.add($arrowRight).find('img'), 1, {
                    opacity: 1,
                    delay: 0.2,
                    clearProps: 'all'
                  })
                  .to($carousel.children().first().find('.see-the-look'), 1, {
                    opacity: 0,
                    display: 'none'
                  });
              }

              // Assign SPP urls to each successfully processed .el_product
              (function () {
                // DOM
                var $howToProducts = $self.find('.see-the-look .el-product');

                $howToProducts.each(function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var data = $this.data('full_product_json');

                  if (typeof data === 'undefined') {
                    return;
                  }

                  if ($this.is('a') && typeof data.url === 'string' && data.url.length !== 0) {
                    $this.attr('href', data.url);
                  }
                });
              })();

              // Mark slides as un-viewed at start
              $carousel.children().not('.first').addClass('needs-intro');
            }
            // END: Init

            // BEGIN: Events
            {
              // See the look button, displays .see-the-look in the slide for 2 secs
              $siteContainer.find('.see-the-look-button a').on('click', function (e) {
                var $this = $(this);
                var $seeTheLook = $this.closest('.slide').find('.see-the-look');
                var lookTimeline = new TimelineMax();

                e.preventDefault();

                // Mark section for see-the-look as active
                $this.closest('.slide').addClass('see-the-look-active');

                TweenMax.killTweensOf($seeTheLook);

                lookTimeline
                  .to($seeTheLook, 1, {
                    display: 'table',
                    opacity: 1
                  })
                  .from($seeTheLook, 1, { y: '+=5%' }, 0)
                  .to($seeTheLook.find('.close-panel'), 0.5, {
                    opacity: 1,
                    display: 'block'
                  }, 0);
              });

              $self.find('.see-the-look .close-panel').on('click', function (e) {
                var $this = $(this);
                var closeTimeline = new TimelineMax({
                  paused: true,
                  onComplete: function () {
                    $self.removeClass('see-the-look-active');
                  }
                });
                var $seeTheLook = $this.closest('.see-the-look');

                e.preventDefault();

                closeTimeline
                  .to($seeTheLook, 1, {
                    display: 'none',
                    opacity: 0
                  })
                  .to($seeTheLook.find('.close-panel'), 1, {
                    opacity: 0,
                    display: 'none'
                  });
                closeTimeline.play();
              });

              // Swipe events, this will be enabled/disabled via setDesktopMode/setMobileMode
              $self.swipe({
                swipeLeft: function () {
                  if ($self.hasClass('see-the-look-active')) {
                    return;
                  }

                  $carousel.carouselNext();
                },
                swipeRight: function () {
                  if ($self.hasClass('see-the-look-active')) {
                    return;
                  }

                  $carousel.carouselPrev();
                },
                allowPageScroll: 'vertical',
                preventDefaultEvents: false
              });

              // Enable or disable desktop/mobile functionality
              if (!isMobile) {
                setDesktopMode();
              } else {
                setMobileMode();
              }

              // Events to trigger desktop/mobile functionality
              $(window)
                .on('desktopLostMobile', setDesktopMode)
                .on('desktopGainedMobile', setMobileMode);

              // Displays the right side swatches on click, rotates the plus sign from + to x
              $carousel.find('.open-panel')
                .on('mouseenter', function (e) {
                  e.preventDefault();

                  if (!(isMobile || isIpad)) {
                    crossToggle.apply(this, [e, true]);
                  }
                })
                .on('mouseleave', function (e) {
                  e.preventDefault();

                  if (!(isMobile || isIpad)) {
                    crossToggle.apply(this, [e, false]);
                  }
                })
                // Mobile only, as 'hover' doesn't work or is weirdly handled
                .on('click', function (e) {
                  e.preventDefault();

                  if (isMobile || isIpad) {
                    crossToggle.apply(this, [e]);
                  }
                });

              $carousel.find('.slide').find('.el-product_shop-now-container:not(.see-the-look-button) .el-product_shop-now').not('.quickshop, .empty').on('click', function (e) {
                // DOM
                var $this = $(this);
                var $mppSection = $siteContainer.find('#vb_section-6');
                var $target;
                // LOGIC
                var target = $this.data('target');

                e.preventDefault();

                $target = $siteContainer.find('.mpp.' + target);

                if ($target.length !== 0) {
                  TweenMax.to($window, 1, {
                    scrollTo: {
                      y: $target.offset().top,
                      autoKill: false
                    }
                  });
                }

                // Toggle current location MPP choice
                $mppSection.find('#mpp-location ul').find('.' + target).trigger('click');
                // Toggle active on the currently active product filter
                $mppSection.find('#mpp-category-container li.active').trigger('click');
              });

              // Scrolls to selector with target data value
              $self.find('.column.right .el-product_shop-now-container a').on('click', function (e) {
                // DOM
                var $this = $(this);
                var $target;
                // LOGIC
                var target = $this.data('scroll-target');
                var offset = $siteContainer.offset().top;

                e.preventDefault();

                if (typeof target !== 'string' || target.trim().length === 0) {
                  return;
                }

                $target = $(target);

                if ($target.length === 0) {
                  return;
                }

                TweenMax.to($window, 1, {
                  scrollTo: {
                    y: $target.offset().top - offset,
                    autoKill: false
                  }
                });
              });
            }
            // END: Init

            MAIN.add(generateSection($self, {
              update: function (position) {
                if (!introTimedlineStarted && position >= 0.4) {
                  introTimeline.play();
                  introTimedlineStarted = true;
                }

                // When in mobile $currentSlide's bottom reaches near or past the top, animate in the next slide
                if (isMobile && $self.find('.mobilefinished').length !== $self.find('.slide').length) {
                  $carousel.children().each(function () {
                    var $this = $(this);
                    var slideTimeline = new TimelineMax({
                      paused: true,
                      onComplete: function () {
                        $this.addClass('mobilefinished');
                      }
                    });

                    if ($this.offset().top < $window.scrollTop() + $window.height()) {
                      if ($this.hasClass('mobileStarted')) {
                        return;
                      }

                      $this.addClass('mobileStarted');

                      slideTimeline
                        .to($this, 1, {
                          y: '0%',
                          opacity: 1
                        })
                        .to($this.find('.see-the-look'), 1, {
                          opacity: 0,
                          display: 'none'
                        }, '+=1');

                      slideTimeline.play();
                    }
                  });
                }
              }
            }));
          })();
          // /////////////////////////////
          // END: Section 5
          // /////////////////////////////

          // /////////////////////////////
          // BEGIN: Section 6 MPP
          // /////////////////////////////
          (function () {
            var $self = $siteContainer.find('#vb_section-6');
            var $locationFilter = $self.find('#mpp-location ul li');
            var $categoryFilter = $self.find('#mpp-category-container ul li');

            if ($self.length === 0) {
              return;
            }

            // Init section with initial products to display
            {
              $locationFilter.removeClass('active');
              $categoryFilter.removeClass('active');
            }

            {
              $(document).on('addToCart.success', function () {
                $window.trigger('addAllToBag.success');
              }).on('addToCart.failure', function () {
                $window.trigger('addAllToBag.failure');
              });

              $locationFilter.on('click touchstart', function (e) {
                // DOM
                var $this = $(this);
                var $targetMPP;
                // LOGIC
                var target = $this.data('target');

                e.preventDefault();
                e.stopPropagation();

                if (typeof target !== 'string' || target.trim().length === 0) {
                  return;
                }

                $targetMPP = $(target);

                if ($targetMPP.length !== 0) {
                  TweenMax.to($window, 1, {
                    scrollTo: {
                      y: $targetMPP.offset().top - $siteContainer.offset().top,
                      autoKill: false
                    }
                  });
                }
              });

              $categoryFilter.on('click touchstart', function (e) {
                var $this = $(this);

                e.preventDefault();
                e.stopPropagation();

                if (!$this.hasClass('active')) {
                  $this.addClass('active').siblings().removeClass('active');
                } else {
                  $this.removeClass('active');
                }

                // Blow out classes
                $categoryFilter.each(function () {
                  $siteContainer.removeClass($(this).data('slot_name'));
                });

                $siteContainer.addClass($this.data('slot_name'));
              });
            }

            MAIN.add(generateSection($self, {}));
          })();
          // /////////////////////////////
          // END: Section 6 MPP
          // /////////////////////////////
        });

        // /////////////////////////////////
        // BEGIN: COREMETRICS
        // /////////////////////////////////
        (function () {
          var forceFlag;
          var cmSettings;

          if (window.location.href.indexOf('dynamic.li') > -1) {
            return;
          }

          forceFlag = $siteContainer.hasClass('it_IT') ? 1 : 0;
          cmSettings = {
            options: {
              debug: debug,
              cat_id: 'CAT', // CAT ID
              element_cat: 'Estee Supreme Boutique', // Boutique Name
              force: forceFlag// Force CoreMetrics on some servers
            },
            section: [
              {
                tag: 'Landing',
                element_tag: {

                }
              }
            ]
          };
          $siteContainer.elmetrics(cmSettings);
        })();
        // ///////////////////////////////////
        // END: COREMETRICS
        // ///////////////////////////////////

        // /////////////////////////////////
        // BEGIN: Preloader
        // /////////////////////////////////

        (function () {
          var $loader = $siteContainer.find('#loader');
          var preloadTargets = [];
          var spinnerOptions = {
            lines: 17, // The number of lines to draw
            length: 0, // The length of each line
            width: 5, // The line thickness
            radius: 26, // The radius of the inner circle
            scale: 1, // Scales overall size of the spinner
            corners: 1, // Corner roundness (0..1)
            color: '#fff', // #rgb or #rrggbb or array of colors
            opacity: 0.5, // Opacity of the lines
            rotate: 0, // The rotation offset
            direction: 1, // 1: clockwise, -1: counterclockwise
            speed: 1, // Rounds per second
            trail: 30, // Afterglow percentage
            zIndex: 2e9, // The z-index (defaults to 2000000000)
            className: 'spinner', // The CSS class to assign to the spinner
            top: '50%', // Top position relative to parent
            left: '50%', // Left position relative to parent
            shadow: false, // Whether to render a shadow
            hwaccel: true, // Whether to use hardware acceleration
            position: 'absolute' // Element positioning
          };
          var spinner = new Spinner(spinnerOptions).spin($loader[0]);
          var deeplinkData = deeplink.get();
          var $deeplinkSection;
          var deeplinkIsMPP = false;
          // Object/SVG loading
          var $objects = $siteContainer.find('object');
          var objectsToLoad = $objects.length;
          var objectsLoaded = 0;

          /**
          * @function triggerPreload
          * @description Helper function for preload
          * @returns {undefined} This function doesn't return anything
          */
          function triggerPreload() {
            if (debug) {
              console.log('triggerPreload: Preload Triggered');
            }

            $(preloadTargets).FreeLoader({
              debug: false,
              loadTimeout: 10000,
              callback: function () {
                // Ensure the rest of the images have been swapped in
                $siteContainer.find('img, .preload').each(function () {
                  var $this = $(this),
                    dataSrc = $this.data('src');

                  if (typeof dataSrc !== 'undefined') {
                    $this.attr('src', dataSrc);
                  }
                });

                // Delay used to ensure enough images are loaded before displaying site
                TweenMax.to($loader, 1, {
                  opacity: 0,
                  display: 'none',
                  delay: 2,
                  onComplete: function () {
                    spinner.stop();
                    $window.trigger('scroll');

                    // Deeplink handling
                    if (!deeplinkIsMPP && typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0 && typeof $deeplinkSection.data('section') !== 'undefined') {
                      $deeplinkSection.data('section').deeplink();
                    } else if (deeplinkIsMPP) {
                      TweenMax.to($window, 1, {
                        scrollTo: { y: $deeplinkSection.offset().top },
                        onComplete: function () {
                          deeplinking = false;
                        }
                      });
                    } else {
                      deeplinking = false;
                    }
                  }
                });

                postLoad();
              }
            });
          }

          // parse Prod ID list, match with SKUs in page_data and assign them to the el-product elements
          setProductsAndSkus($siteContainer.find('.vb_section-3_product-hover'));
          setProductsAndSkus($siteContainer.find('.vb_section-5_signature-hovers'));
          setProductsAndSkus($siteContainer.find('.vb_section-5_london-hovers'));
          setProductsAndSkus($siteContainer.find('.vb_section-5_ny-hovers'));
          setProductsAndSkus($siteContainer.find('.vb_section-5_la-hovers'));
          setProductsAndSkus($siteContainer.find('.vb_section-5_paris-hovers'));
          setProductsAndSkus($siteContainer.find('.vb_section-5_miami-hovers'));

          // Run EL Product plugin
          $('#vb_section-3, #vb_section-5').elproduct({
            'target': '.el-product',
            'template': '.el-product_template-markup .el-product',
            'products': '.el-product_id-list',
            'debug': false,
            onSuccess: function () {
              $('.el-product_shadename').each(function () {
                // DOM
                var $this = $(this);
                // LOGIC
                var hexColor = $this.data('swatch-color');

                if (typeof hexColor !== 'undefined') {
                  $this.siblings('.el-swatch').css({ backgroundColor: hexColor });
                }

                // Look for formattedUnitPrice per .el-product
                if (typeof $siteContainer.data('use-unit-price') !== 'undefined') {
                  $('#vb_section-3, #vb_section-5').find('.el-product').each(function () {
                    // DOM
                    var $this = $(this);
                    var $price = $this.find('.el-product_price');
                    // LOGIC
                    var productData = $this.data('full_product_json');
                    var skuData;
                    var unitPrice;
                    var price;
                    var measurement;

                    // Attempt to find and use 'formattedUnitPrice' field if available
                    if (typeof productData !== 'undefined' && typeof productData.skus !== 'undefined' && productData.skus.length !== 0) {
                      skuData = productData.skus[0];
                      unitPrice = skuData.formattedUnitPrice;
                      price = skuData.formattedPrice;
                      measurement = skuData.PRODUCT_SIZE;

                      // Must have all fields to replace price
                      if (typeof unitPrice === 'string' && unitPrice.trim().length !== 0 && typeof price === 'string' && price.trim().length !== 0 && typeof measurement === 'string' && measurement.trim().length !== 0) {
                        $price.html('<span class="size">' + measurement + '</span> <span class="price">' + price + '</span><br /><span ="unit-price">' + unitPrice + '</span>');
                      }
                    }
                  });
                }

                // Handle add to cart or quickshop
                $siteContainer.find('.el-product .el-product_shop-now, a.el-product.quickshop').off('click').on('click', function (e) {
                  // DOM
                  var $this = $(this);
                  var $parent = $this.closest('.el-product');
                  // LOGIC
                  var data = $parent.data('full_product_json');

                  e.stopPropagation();

                  if (typeof data === 'undefined') {
                    return;
                  }

                  // Display quickshop
                  if ($this.hasClass('quickshop')) {
                    e.preventDefault();

                    site.quickshop(data);
                  }
                  // Display add to bag
                  else if ($this.hasClass('add-to-bag')) {
                    e.preventDefault();

                    site.addToCart({
                      skuData: {
                        SKU_BASE_ID: data.skus[0].SKU_ID.replace(/[A-z]+/, ''),
                        PARENT_CAT_ID: data.PRODUCT_ID
                      },
                      quantity: 1,
                      QTY: 1
                    });
                  }
                });
              });
            }
          });

          // Process deeplink
          // Check if it's an MPP deeplink
          if (deeplinkData.indexOf('mpp') !== -1 && deeplinkData.length > 1) {
            $deeplinkSection = $siteContainer.find('.' + deeplinkData.join('.'));
            deeplinkIsMPP = true;
          // Normal section deeplink
          } else if (deeplinkData.length !== 0) {
            $deeplinkSection = $siteContainer.find('#' + deeplinkSectionIDPart + deeplinkData[0]);
          }

          // Deeplink'd section gets priority over all other sections
          if (deeplinkIsMPP) {
            preloadTargets.push($deeplinkSection.find('img, .preload').not(isMobile ? '.desktop' : '.mobile'));
          }

          $siteContainer.find('.vb_section').each(function () {
            preloadTargets.push($(this).find('img, .preload').not(isMobile ? '.desktop' : '.mobile'));
          });

          if (typeof $deeplinkSection !== 'undefined' && $deeplinkSection.length !== 0) {
            deeplinking = true;
          }

          // Load objects if there are any, otherwise skip to image preloading
          if (objectsToLoad !== 0) {
            if (debug) {
              console.log('Found: ' + objectsToLoad, $objects);
            }

            // Attach load event to each object
            $objects.each(function () {
              var $this = $(this);

              // Object must have data set and not blank, if so decrement and don't listen for load
              if (typeof $this.attr('data') === 'undefined' || $this.attr('data').trim().length === 0 || $this.hasClass('loaded')) {
                if (debug) {
                  console.log('No data to load from: ', $this);
                }

                objectsToLoad--;

                if (objectsToLoad === 0) {
                  triggerPreload();
                }

                return;
              }

              if (debug) {
                console.log('Loading data for: ', $this);
              }

              this.addEventListener('load', function () {
                objectsLoaded++;

                if (debug) {
                  console.log('Loaded: ', $this);
                }

                // Trigger normal image preloading after objects have loaded
                if (objectsLoaded >= objectsToLoad) {
                  triggerPreload();
                }
              });
            });
          } else {
            triggerPreload();
          }
        }());

        // /////////////////////////////////
        // END: Preloader
        // /////////////////////////////////

        // /////////////////////////////
        // BEGIN: Sold Out Product Handling
        // /////////////////////////////
        (function () {
          {
            // Get product IDs
            $(document).on('prodcat.status', function (e, data) {
              var product;
              var products = data.products;
              var productID;
              var productIsShoppable;
              var d = 0;

              for (d = 0; d < products.length; d++) {
                product = products[d];
                productID = product.PRODUCT_ID;
                productIsShoppable = product.isShoppable;

                // ProductIDs that are not shoppable are added to soldOutProductIDs
                if (typeof productID !== 'undefined' && typeof productIsShoppable !== 'undefined' && productIsShoppable === 0 && soldOutProductIDs.indexOf(productID) === -1) {
                  soldOutProductIDs.push(productID);
                }
              }

              $window.trigger('updateProductsToSoldOut');
            });
          }
        })();
        // /////////////////////////////
        // END: Sold Out Product Handling
        // /////////////////////////////

        // /////////////////////////////
        // BEGIN: Post Init
        // /////////////////////////////
        (function () {
          var tag = document.createElement('script');
          var firstScriptTag;

          tag.src = 'https://www.youtube.com/iframe_api';
          firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        })();
        // /////////////////////////////
        // END: Post Init
        // /////////////////////////////
      }());

      // /////////////////////////////////
      // END: Boutique Implementation
      // /////////////////////////////////
    }
  };
})(jQuery);
